<template>
    <rkm-modal
        :loading="loading"
        :buttons="['cancel']"
        :title="`Reservas (${material})`"
        large
        ref="Modal"
    >
        <rkm-table
            :fields="fields"
            :items="reservas"
            hide-filters
        >
            <template v-slot:cell(lote)="{ value }">
                {{ value || '-' }}
            </template>

            <template v-slot:cell(validadeLote)="{ value }">
                {{ value || '-' }}
            </template>

            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$refs.ModalRequisicao.open(item)"
                    color="primary"
                    small
                    title="Visualizar requisições com reserva"
                >
                    <rkm-icon icon="list" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalRequisicao ref="ModalRequisicao" />
    </rkm-modal>
</template>

<script>
import ModalRequisicao from './components/requisicao/Modal'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { ModalRequisicao },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: 'fornecedor.nomeFantasia',
                    label: 'Fornecedor',
                },
                {
                    key: 'lote',
                    label: 'Lote',
                    class: 'col-min text-center'
                },
                {
                    key: 'validadeLote',
                    label: 'Validade',
                    class: 'col-min text-center'
                },
                {
                    key: 'estoque',
                    label: 'Estoque total',
                    class: 'col-min text-center'
                },
                {
                    key: 'reservado',
                    label: 'Reservado',
                    class: 'col-min text-center'
                },
                {
                    key: 'estoqueDisponivel',
                    label: 'Estoque disponível',
                    class: 'col-min text-center'
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                }
            ]
        },
    },
    data: () => ({
        material: '',
        reservas: [],
    }),
    methods: {
        open(item) {

            this.material = item.material.descricaoCompleta
            this.reservas = item.reservas

            this.$refs.Modal.show()
        }
    },
}
</script>